"use strict";
exports.__esModule = true;
exports.getAvailableModels = exports.getErrors = exports.getEnvVariables = exports.getCurrentActionData = exports.getCurrentActionsList = exports.getCurrentAgentData = exports.getCurrentAgentId = exports.getAgentsList = exports.getDomainName = exports.getDomainId = void 0;
exports.getDomainId = function (state) {
    return state.aiAgent.domainId;
};
exports.getDomainName = function (state) {
    return state.aiAgent.domainName;
};
exports.getAgentsList = function (state) {
    return state.aiAgent.agentsList;
};
exports.getCurrentAgentId = function (state) {
    return state.aiAgent.currentAgentId;
};
exports.getCurrentAgentData = function (state) {
    return state.aiAgent.currentAgentData;
};
exports.getCurrentActionsList = function (state) {
    return state.aiAgent.actionsList;
};
exports.getCurrentActionData = function (state) {
    return state.aiAgent.currentActionData;
};
exports.getEnvVariables = function (state) {
    return state.aiAgent.envVariables;
};
exports.getErrors = function (state) {
    return state.aiAgent.errors;
};
exports.getAvailableModels = function (state) {
    return state.aiAgent.availableModels;
};
